export const DragTypes = {
  FIELD: 'field',
}
